import React, { useMemo, useRef, useEffect, useState } from "react";
import { useStats } from "react-instantsearch";

export const MyStats = (props) => {
  const { nbHits} = useStats();
  return <span>{nbHits}</span>;
};
